export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8987.a1bba6cf.jpg";